import { Helmet } from "react-helmet";

function MetaTags({ title = '', description = ''}) {
    return (
        <Helmet>
            { /* Standard metadata tags */}
            <title>{title}</title>
            <meta name='description' content={description} />           
        </Helmet>
    );
}

export default MetaTags;